import React from 'react'
import style from './ActionWithEx.module.scss'
import { ReactComponent as SubmitReview } from 'components/UI/icons/revision_info.svg'
import Marks from './Marks/Marks'

const ActionWithEx = ({
  setMark,
  homework,
  addMark,
  sendToRevision,
  pastLesson,
  translate,
}) => {
  return (
    <div className={style.container}>
      <div>
        <h3>{translate.action_with_homework}</h3>
      </div>
      <div className={style.review}>
        <div className={style.reviewBtn} onClick={sendToRevision}>
          <SubmitReview />
          <span>{translate.submit_hm}</span>
        </div>
      </div>
      <div className={style.delimiter}>
        <div className={style.line}></div>
        <div className={style.text}>{translate.or_rate}</div>
      </div>
      <div className={style.marks}>
        <Marks
          type={homework?.company_mark_type || pastLesson?.company_mark_type}
          setMark={setMark}
          addMark={addMark}
          translate={translate}
        />
      </div>
    </div>
  )
}

export default ActionWithEx
